import { render, staticRenderFns } from "./ProductCente.vue?vue&type=template&id=4e36fd11&scoped=true"
import script from "./ProductCente.vue?vue&type=script&lang=js"
export * from "./ProductCente.vue?vue&type=script&lang=js"
import style0 from "./ProductCente.vue?vue&type=style&index=0&id=4e36fd11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36fd11",
  null
  
)

export default component.exports